export const my_routes = {
  // Routes - Authentifications
  home: "/",
  login: "/login",
  resetPassword: "/reset-password",
  forgotPassword: "/forgot-password",
  changePassword: "/change-password",

  // Route - Pages
  profile: "/profile",

  // Route - Gestion utilisateurs
  newUser: "/new-user",
  allUser: "/all-user",
  editUser: "/edit-user/:id",
  rolesPermissions: "/roles-permissions",
  department: "/departements",

  //Route - Gestion parents
  allParent: "/all-parent",

  // Route - Gestion des étudiants
  registrationStudent: "/registration-student",
  allStudent: "/all-student",
  editStudent: "/edit-student/:id",
  studentDetailsPage: "/student-detail/:id",
  studentAbsence: "/student-absence",
  sanctions: "/student-sanctions",

  // Route - Gestion des Professeurs
  allTeacher: "/all-teacher",
  editTeacher: "/edit-teacher/:id",
  createTeacher: "/new-teacher",
  teacherDetailsPage: "/teacher-detail/:id",
  hourlyRateTeacher: "/teacher-hourlyRate",
  teacherReport: "/teacher-report",

  // Route - Gestion des Notes
  allNotes : "/all-notes",
  studentNotes:"/student-note",
  noteExterne:"/external-note",
  restrictionNote: "/finance/restriction-note",
  
  // Route - Gestion des Evaluations
  evaluationList: "/all-evaluations",

  // Route - Dashboards
  studentDashboard: "/student-dashboard",
  parentDashboard: "/parent-dashboard",
  teacherDashboard: "/teacher-dashboard",
  adminDashboard: "/admin-dashboard",
  superAdminDashboard: "/super-admin-dashboard",

  // Route - AcademicYear
  academicYear: "/academic-year",
  evaluationPeriod: "evaluation-period",
  ue: "all-ue",

  // Route - EDT
  timeTableManager: "/time-table-manager",
  timeTableList: "/time-table-list",
  coursList: "/cours-list",

  //Elements Pédagogiques
  levelList: "/all-levels",
  classroomList: "/all-classrooms",
  subjectList: "/all-subjects",
  classList: "/all-classes",

  // Route - Documentation
  docs: "/docs",

  //Route - Paramètres
  settings: "/settings",

  // Route - Classement
  classementByClass: "/classement-by-class",
  classementByPromotion: "/classement-by-promotion",

  // Route - Message
  messagePage : "/message-manager",

  // Route - Finance
  financeHome : "/finance",
  PaymentPlan : "/finance/payment-plan",
  allPayment : "/finance/all-payment",
  bourseAndRemise: "/finance/bourse-remise",

  // Route - Requests
  requestList : "/requests",
  requestDetails : "/request-details/:id",

  // Route - Memory
  memoryList : "/memories",
  memoryDetails : "/memoryDetails/:id",
  // Route - Visiteurs
  visitorList: "/visitors",
  
  // Route - Reclamation
  claimList: "/claims",
  claimDetails: "/claim-details/:subjectUEId/:studentId",
  
  // Route - Planning Examen
  planingExam : "/planning-exam",
  examDetails : "/exam/:id",

  //Diplome
  decisionList : "/decision-list",
  decisionDetails : "/decision-details/:id",
  diplomeList : "/diplomes/:id",
  diplomeDetails: "/diplomes/:idDecision/:id",

  // Route - uiAvatar
  trombinoscope: "/trombinoscope",

  // Route- events
  eventPage : "/eventPage",

  //other
   lockScreen: "/lock-screen",

};

export const public_routes = {
  // Routes - Authentifications
  home: "/",
  login: "/login",
  resetPassword: "/reset-password",
  forgotPassword: "/forgot-password",
  changePassword: "/change-password",

  //other
  lockScreen: "/lock-screen",
};

export const student_routes = {
  // Route - Pages
  profile: "/profile",

  // Route - Dashboards
  home: "/",
  studentDashboard: "/student-dashboard",

  // Route - Emploi du temps
  studentEDT: "/edt",

  // Route - Absences
  studentAttendance: "/my-attendance",

  // Route - Notes
  studentNote: "/my-grades",

  // Route - Cours
  studentCourse: "/my-courses",
  courseDetails: "/course/:id",

  // Route - Messages
  messagePage: "/message-manager",

  // Route - Requests
  requestList : "/requests",

  //Route - Payment
  paymentList: "/payments",

  // Route - Claim
  myClaims : "/myClaims",
  createClaim : "/newClaim",
  claimDetails : "/claim/:id",

  // Route - Planning Examen
  myExams : "/myExams",
  examDetails : "/myExam/:id",

  //other
  lockScreen: "/lock-screen",
};

export const parent_routes = {
  // Route - Pages
  profile: "/profile",

  // Route - Dashboards
  home: "/",
  parentDashboard: "/parent-dashboard",

  // Route - Emploi du temps
  studentEDT: "/edt",
  
  // Route - Cours
  studentCourse: "/courses",
  courseDetails: "/course/:id",

  // Route - Notes
  studentNote: "/grades",
  
  // Route - Absences
  studentAttendance: "/attendance",
  
  //Route - Payment
  paymentList: "/payments",
  
  // Route - Planning Examen
  childExams : "/childExams",
  examDetails: "/childExam/:id",
  
  // Route - Requests
  requestList: "/requests",
  
  // Route - Claim

claims: "/claims",
createClaim : "/newClaim",
claimDetails : "/claim/:id",
  
  //other
  lockScreen: "/lock-screen",
  
  // Route - Messages
  messagePage: "/message-manager",
};

export const prof_routes = {
  // Route - Pages
  profile: "/profile",

  // Route - Dashboards
  home: "/",
  teacherDashboard: "/teacher-dashboard",

  // Route - Emploi du temps
  teacherEDT: "/edt",

  // Route - Notes
  teacherNote: "/my-grades",

  // Route - Cours
  teacherCourse: "/my-courses",
  teacherCourseDetails: "/teacher/course/:id",

  // Route - Messages
  messagePage: "/message-manager",

  //other
  lockScreen: "/lock-screen",
};
